import React from "react"
import PropTypes from "prop-types"

const Hashnode = ({ color }) => {
  return (
    <svg
      version="1.1"
      role="img"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="337"
      height="337"
      viewBox="0 0 337 337"
    >
      <path
        id="Hashnode"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.155 112.598c-30.873 30.874-30.873 80.93 0 111.804l89.443 89.443c30.874 30.873 80.93 30.873 111.804 0l89.443-89.443c30.873-30.874 30.873-80.93 0-111.804l-89.443-89.443c-30.874-30.873-80.93-30.873-111.804 0l-89.443 89.443zm184.476 95.033c21.612-21.611 21.612-56.651 0-78.262-21.611-21.612-56.651-21.612-78.262 0-21.612 21.611-21.612 56.651 0 78.262 21.611 21.612 56.651 21.612 78.262 0z"
        fill="black"
      />
    </svg>
  )
}

Hashnode.propTypes = {
  color: PropTypes.string,
}

Hashnode.defaultProps = {
  color: "#000000",
}

export default Hashnode
